import React from "react";
import { Button, ButtonProps } from "semantic-ui-react";

interface TwoWayCommunicationButtonProps {
  onClick: (ev: React.MouseEvent<HTMLButtonElement, MouseEvent>, data: ButtonProps) => void;
}
export default function TwoWayCommunicationButton({ onClick }: TwoWayCommunicationButtonProps) {
  return (
    <Button
      onClick={onClick}
      className='tw-border-[1px] tw-border-solid tw-border-[#0000001A] tw-bg-[#007AC61A] tw-text-[#000000E5]'
    >
      Ask a Question?
    </Button>
  );
}
